import { render, staticRenderFns } from "./StudentActivityTableTextCell.vue?vue&type=template&id=05227086&scoped=true&"
import script from "./StudentActivityTableTextCell.vue?vue&type=script&lang=ts&"
export * from "./StudentActivityTableTextCell.vue?vue&type=script&lang=ts&"
import style0 from "./StudentActivityTableTextCell.vue?vue&type=style&index=0&id=05227086&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05227086",
  null
  
)

export default component.exports